import React from 'react';

const defaultProps = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': 'true',
};

// 🎮 Game Controller Icon (Navbar & Play Games)
export const GameControllerIcon = ({ size = 18, className = '', style = {}, ...props }) => (
  <svg {...defaultProps} width={size} height={size} className={className} style={{ display: 'inline-block', verticalAlign: 'middle', ...style }} {...props}>
    <rect x="2" y="6" width="20" height="12" rx="4" />
    <path d="M6 12h4" />
    <path d="M8 10v4" />
    <circle cx="15" cy="11" r="1" fill="currentColor" />
    <circle cx="17" cy="13" r="1" fill="currentColor" />
  </svg>
);

// 🏆 Trophy Icon (Ranking, Leaderboard, Prizes)
export const TrophyIcon = ({ size = 18, className = '', style = {}, ...props }) => (
  <svg {...defaultProps} width={size} height={size} className={className} style={{ display: 'inline-block', verticalAlign: 'middle', ...style }} {...props}>
    <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6" />
    <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18" />
    <path d="M4 4h16v6a8 8 0 0 1-16 0V4z" />
    <path d="M12 18v3" />
    <path d="M8 21h8" />
  </svg>
);

// ⛪ Church / Chapel Icon (Host Studio, Church Leagues)
export const ChurchIcon = ({ size = 18, className = '', style = {}, ...props }) => (
  <svg {...defaultProps} width={size} height={size} className={className} style={{ display: 'inline-block', verticalAlign: 'middle', ...style }} {...props}>
    <path d="M12 2v3" />
    <path d="M10.5 3.5h3" />
    <path d="M12 5 6 9v12h12V9l-6-4z" />
    <path d="M10 21v-4a2 2 0 0 1 4 0v4" />
  </svg>
);

// 📖 Open Bible / Scripture Icon
export const BibleIcon = ({ size = 18, className = '', style = {}, ...props }) => (
  <svg {...defaultProps} width={size} height={size} className={className} style={{ display: 'inline-block', verticalAlign: 'middle', ...style }} {...props}>
    <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" />
    <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
    <path d="M17 7v4" />
    <path d="M15 9h4" />
  </svg>
);

// ✍️ Blog / Article Icon
export const BlogIcon = ({ size = 18, className = '', style = {}, ...props }) => (
  <svg {...defaultProps} width={size} height={size} className={className} style={{ display: 'inline-block', verticalAlign: 'middle', ...style }} {...props}>
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="16" y1="13" x2="8" y2="13" />
    <line x1="16" y1="17" x2="8" y2="17" />
    <polyline points="10 9 9 9 8 9" />
  </svg>
);

// 💬 Support / Chat Icon
export const SupportIcon = ({ size = 18, className = '', style = {}, ...props }) => (
  <svg {...defaultProps} width={size} height={size} className={className} style={{ display: 'inline-block', verticalAlign: 'middle', ...style }} {...props}>
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    <circle cx="8" cy="10" r="1" fill="currentColor" />
    <circle cx="12" cy="10" r="1" fill="currentColor" />
    <circle cx="16" cy="10" r="1" fill="currentColor" />
  </svg>
);

// 🤝 Volunteer / Handshake / Community Icon
export const VolunteerIcon = ({ size = 18, className = '', style = {}, ...props }) => (
  <svg {...defaultProps} width={size} height={size} className={className} style={{ display: 'inline-block', verticalAlign: 'middle', ...style }} {...props}>
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

// ❤️ Heart / Support Mission Icon
export const HeartIcon = ({ size = 18, className = '', style = {}, ...props }) => (
  <svg {...defaultProps} width={size} height={size} className={className} style={{ display: 'inline-block', verticalAlign: 'middle', ...style }} {...props}>
    <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
  </svg>
);

// 🗂️ Grid / Collection Icon (Replaces shiny sparkles ✨ for "All" category)
export const GridCategoryIcon = ({ size = 18, className = '', style = {}, ...props }) => (
  <svg {...defaultProps} width={size} height={size} className={className} style={{ display: 'inline-block', verticalAlign: 'middle', ...style }} {...props}>
    <rect x="3" y="3" width="7" height="7" rx="1.5" />
    <rect x="14" y="3" width="7" height="7" rx="1.5" />
    <rect x="14" y="14" width="7" height="7" rx="1.5" />
    <rect x="3" y="14" width="7" height="7" rx="1.5" />
  </svg>
);

// 🌱 Sprout / Youth Icon (Youth Ministry)
export const SproutIcon = ({ size = 18, className = '', style = {}, ...props }) => (
  <svg {...defaultProps} width={size} height={size} className={className} style={{ display: 'inline-block', verticalAlign: 'middle', ...style }} {...props}>
    <path d="M12 22v-8" />
    <path d="M12 14c0-5 4-8 9-8-1 5-4 8-9 8Z" />
    <path d="M12 17c0-3.5-3-5.5-7-5.5.7 3.5 3 5.5 7 5.5Z" />
  </svg>
);

// 🙏 Faith / Prayer Cross Icon (Faith & Growth)
export const FaithCrossIcon = ({ size = 18, className = '', style = {}, ...props }) => (
  <svg {...defaultProps} width={size} height={size} className={className} style={{ display: 'inline-block', verticalAlign: 'middle', ...style }} {...props}>
    <circle cx="12" cy="12" r="9" strokeWidth="1.5" />
    <path d="M12 7v10" />
    <path d="M8.5 10.5h7" />
  </svg>
);

// 🔍 Search Icon
export const SearchIcon = ({ size = 18, className = '', style = {}, ...props }) => (
  <svg {...defaultProps} width={size} height={size} className={className} style={{ display: 'inline-block', verticalAlign: 'middle', ...style }} {...props}>
    <circle cx="11" cy="11" r="8" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);

// ⚙️ Filter Sliders Icon
export const FilterSlidersIcon = ({ size = 18, className = '', style = {}, ...props }) => (
  <svg {...defaultProps} width={size} height={size} className={className} style={{ display: 'inline-block', verticalAlign: 'middle', ...style }} {...props}>
    <line x1="4" y1="21" x2="4" y2="14" />
    <line x1="4" y1="10" x2="4" y2="3" />
    <line x1="12" y1="21" x2="12" y2="12" />
    <line x1="12" y1="8" x2="12" y2="3" />
    <line x1="20" y1="21" x2="20" y2="16" />
    <line x1="20" y1="12" x2="20" y2="3" />
    <line x1="1" y1="14" x2="7" y2="14" />
    <line x1="9" y1="8" x2="15" y2="8" />
    <line x1="17" y1="16" x2="23" y2="16" />
  </svg>
);

// 📧 Mail / Envelope Icon
export const MailIcon = ({ size = 18, className = '', style = {}, ...props }) => (
  <svg {...defaultProps} width={size} height={size} className={className} style={{ display: 'inline-block', verticalAlign: 'middle', ...style }} {...props}>
    <rect x="2" y="4" width="20" height="16" rx="2" />
    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
  </svg>
);

// 📱 Smartphone Icon
export const SmartphoneIcon = ({ size = 18, className = '', style = {}, ...props }) => (
  <svg {...defaultProps} width={size} height={size} className={className} style={{ display: 'inline-block', verticalAlign: 'middle', ...style }} {...props}>
    <rect x="5" y="2" width="14" height="20" rx="3" />
    <path d="M12 18h.01" />
  </svg>
);

// 💼 Briefcase Icon
export const BriefcaseIcon = ({ size = 18, className = '', style = {}, ...props }) => (
  <svg {...defaultProps} width={size} height={size} className={className} style={{ display: 'inline-block', verticalAlign: 'middle', ...style }} {...props}>
    <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
    <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
  </svg>
);

// CheckCircleIcon (Replaces shiny sparkles ✨ in confirmations)
export const CheckCircleIcon = ({ size = 24, className = '', style = {}, ...props }) => (
  <svg {...defaultProps} width={size} height={size} className={className} style={{ display: 'inline-block', verticalAlign: 'middle', ...style }} {...props}>
    <circle cx="12" cy="12" r="10" />
    <path d="m9 12 2 2 4-4" />
  </svg>
);

// ⚡ Lightning / Flash Icon
export const LightningIcon = ({ size = 18, className = '', style = {}, ...props }) => (
  <svg {...defaultProps} width={size} height={size} className={className} style={{ display: 'inline-block', verticalAlign: 'middle', ...style }} {...props}>
    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
  </svg>
);

// 🛡️ Shield Icon
export const ShieldIcon = ({ size = 18, className = '', style = {}, ...props }) => (
  <svg {...defaultProps} width={size} height={size} className={className} style={{ display: 'inline-block', verticalAlign: 'middle', ...style }} {...props}>
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    <path d="M12 8v6" />
    <path d="M9.5 10.5h5" />
  </svg>
);

// 👑 Crown Icon
export const CrownIcon = ({ size = 18, className = '', style = {}, ...props }) => (
  <svg {...defaultProps} width={size} height={size} className={className} style={{ display: 'inline-block', verticalAlign: 'middle', ...style }} {...props}>
    <path d="m2 4 3 12h14l3-12-6 7-4-7-4 7-6-7zm3 16h14" />
  </svg>
);

// 🔥 Streak / Fire Icon (Daily Streaks)
export const StreakFireIcon = ({ size = 18, className = '', style = {}, ...props }) => (
  <svg {...defaultProps} width={size} height={size} className={className} style={{ display: 'inline-block', verticalAlign: 'middle', ...style }} {...props}>
    <path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 3z" />
  </svg>
);

// 📅 Calendar Icon (Weekly, Monthly, Events)
export const CalendarIcon = ({ size = 18, className = '', style = {}, ...props }) => (
  <svg {...defaultProps} width={size} height={size} className={className} style={{ display: 'inline-block', verticalAlign: 'middle', ...style }} {...props}>
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
    <line x1="16" y1="2" x2="16" y2="6" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
  </svg>
);

// ⏱️ Clock / Time Icon (Durations, Time Taken)
export const ClockIcon = ({ size = 18, className = '', style = {}, ...props }) => (
  <svg {...defaultProps} width={size} height={size} className={className} style={{ display: 'inline-block', verticalAlign: 'middle', ...style }} {...props}>
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </svg>
);

// 🎯 Target / Objective Icon
export const TargetIcon = ({ size = 18, className = '', style = {}, ...props }) => (
  <svg {...defaultProps} width={size} height={size} className={className} style={{ display: 'inline-block', verticalAlign: 'middle', ...style }} {...props}>
    <circle cx="12" cy="12" r="10" />
    <circle cx="12" cy="12" r="6" />
    <circle cx="12" cy="12" r="2" />
  </svg>
);

// ↗️ Share Icon (Replaces shiny sparkles ✨ on Share buttons)
export const ShareIcon = ({ size = 18, className = '', style = {}, ...props }) => (
  <svg {...defaultProps} width={size} height={size} className={className} style={{ display: 'inline-block', verticalAlign: 'middle', ...style }} {...props}>
    <circle cx="18" cy="5" r="3" />
    <circle cx="6" cy="12" r="3" />
    <circle cx="18" cy="19" r="3" />
    <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
    <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
  </svg>
);

// ⭐ Star Icon
export const StarIcon = ({ size = 18, className = '', style = {}, ...props }) => (
  <svg {...defaultProps} width={size} height={size} className={className} style={{ display: 'inline-block', verticalAlign: 'middle', ...style }} {...props}>
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
  </svg>
);

// 👥 Users / Community Group Icon
export const UsersIcon = ({ size = 18, className = '', style = {}, ...props }) => (
  <svg {...defaultProps} width={size} height={size} className={className} style={{ display: 'inline-block', verticalAlign: 'middle', ...style }} {...props}>
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

// ✏️ Edit Pencil Icon
export const PencilEditIcon = ({ size = 16, className = '', style = {}, ...props }) => (
  <svg {...defaultProps} width={size} height={size} className={className} style={{ display: 'inline-block', verticalAlign: 'middle', ...style }} {...props}>
    <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z" />
  </svg>
);

// 🗑️ Trash / Delete Icon
export const TrashIcon = ({ size = 16, className = '', style = {}, ...props }) => (
  <svg {...defaultProps} width={size} height={size} className={className} style={{ display: 'inline-block', verticalAlign: 'middle', ...style }} {...props}>
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
  </svg>
);

// ⚠️ Warning / Alert Icon
export const WarningIcon = ({ size = 18, className = '', style = {}, ...props }) => (
  <svg {...defaultProps} width={size} height={size} className={className} style={{ display: 'inline-block', verticalAlign: 'middle', ...style }} {...props}>
    <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z" />
    <line x1="12" y1="9" x2="12" y2="13" />
    <line x1="12" y1="17" x2="12.01" y2="17" />
  </svg>
);

// ℹ️ Info Icon
export const InfoIcon = ({ size = 18, className = '', style = {}, ...props }) => (
  <svg {...defaultProps} width={size} height={size} className={className} style={{ display: 'inline-block', verticalAlign: 'middle', ...style }} {...props}>
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="16" x2="12" y2="12" />
    <line x1="12" y1="8" x2="12.01" y2="8" />
  </svg>
);

// ▶️ Play Icon
export const PlayIcon = ({ size = 16, className = '', style = {}, ...props }) => (
  <svg {...defaultProps} width={size} height={size} className={className} style={{ display: 'inline-block', verticalAlign: 'middle', ...style }} {...props}>
    <polygon points="5 3 19 12 5 21 5 3" fill="currentColor" stroke="none" />
  </svg>
);

// 📚 Books / Series Icon
export const BooksIcon = ({ size = 18, className = '', style = {}, ...props }) => (
  <svg {...defaultProps} width={size} height={size} className={className} style={{ display: 'inline-block', verticalAlign: 'middle', ...style }} {...props}>
    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
    <line x1="8" y1="6" x2="16" y2="6" />
    <line x1="8" y1="10" x2="14" y2="10" />
  </svg>
);

// 🗣️ / 🌐 Language Icon
export const GlobeLanguageIcon = ({ size = 16, className = '', style = {}, ...props }) => (
  <svg {...defaultProps} width={size} height={size} className={className} style={{ display: 'inline-block', verticalAlign: 'middle', ...style }} {...props}>
    <circle cx="12" cy="12" r="10" />
    <line x1="2" y1="12" x2="22" y2="12" />
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
  </svg>
);

// 👁️ Eye / Viewer Icon
export const EyeIcon = ({ size = 16, className = '', style = {}, ...props }) => (
  <svg {...defaultProps} width={size} height={size} className={className} style={{ display: 'inline-block', verticalAlign: 'middle', ...style }} {...props}>
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

// 📍 Location Pin Icon
export const LocationPinIcon = ({ size = 16, className = '', style = {}, ...props }) => (
  <svg {...defaultProps} width={size} height={size} className={className} style={{ display: 'inline-block', verticalAlign: 'middle', ...style }} {...props}>
    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

// 📊 Bar Chart Icon (Dashboards & Metrics)
export const BarChartIcon = ({ size = 16, className = '', style = {}, ...props }) => (
  <svg {...defaultProps} width={size} height={size} className={className} style={{ display: 'inline-block', verticalAlign: 'middle', ...style }} {...props}>
    <line x1="18" y1="20" x2="18" y2="10" />
    <line x1="12" y1="20" x2="12" y2="4" />
    <line x1="6" y1="20" x2="6" y2="14" />
  </svg>
);

// 🔗 Link Icon (Share Links)
export const LinkIcon = ({ size = 16, className = '', style = {}, ...props }) => (
  <svg {...defaultProps} width={size} height={size} className={className} style={{ display: 'inline-block', verticalAlign: 'middle', ...style }} {...props}>
    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
  </svg>
);

// ❓ Help / Question Mark Icon
export const HelpCircleIcon = ({ size = 18, className = '', style = {}, ...props }) => (
  <svg {...defaultProps} width={size} height={size} className={className} style={{ display: 'inline-block', verticalAlign: 'middle', ...style }} {...props}>
    <circle cx="12" cy="12" r="10" />
    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
    <line x1="12" y1="17" x2="12.01" y2="17" />
  </svg>
);

// 👤 User / Person Icon
export const UserIcon = ({ size = 18, className = '', style = {}, ...props }) => (
  <svg {...defaultProps} width={size} height={size} className={className} style={{ display: 'inline-block', verticalAlign: 'middle', ...style }} {...props}>
    <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);



// 🏅 Olympic / Podium Medal Badge (Replaces unstyled 🥇 🥈 🥉 emojis)
export const MedalBadge = ({ rank = 1, size = 26, className = '', style = {} }) => {
  const configs = {
    1: { bg: 'linear-gradient(135deg, #FBBF24, #D97706)', text: '#FFFFFF', border: '#B45309', label: '1' },
    2: { bg: 'linear-gradient(135deg, #CBD5E1, #64748B)', text: '#FFFFFF', border: '#475569', label: '2' },
    3: { bg: 'linear-gradient(135deg, #FDBA74, #C08552)', text: '#FFFFFF', border: '#9A3412', label: '3' },
  };
  const cfg = configs[rank] || { bg: '#E2E8F0', text: '#334155', border: '#CBD5E1', label: rank };

  return (
    <div
      className={className}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: `${size}px`,
        height: `${size}px`,
        borderRadius: '50%',
        background: cfg.bg,
        color: cfg.text,
        fontSize: `${Math.round(size * 0.5)}px`,
        fontWeight: 800,
        boxShadow: '0 2px 6px rgba(0, 0, 0, 0.16)',
        border: `1.5px solid ${cfg.border}`,
        lineHeight: 1,
        ...style,
      }}
    >
      {cfg.label}
    </div>
  );
};

// ✓ Checkmark Icon (Lists, Requirements, Features)
export const CheckIcon = ({ size = 16, className = '', style = {}, ...props }) => (
  <svg {...defaultProps} width={size} height={size} className={className} style={{ display: 'inline-block', verticalAlign: 'middle', ...style }} {...props}>
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

// 🤝 Handshake / Partnership Icon
export const HandshakeIcon = ({ size = 18, className = '', style = {}, ...props }) => (
  <svg {...defaultProps} width={size} height={size} className={className} style={{ display: 'inline-block', verticalAlign: 'middle', ...style }} {...props}>
    <path d="M19 14v1a3 3 0 0 1-3 3h-2" />
    <path d="M5 10V9a3 3 0 0 1 3-3h2" />
    <path d="M8 14l3 3 7-7" />
    <path d="m2 14 3-3" />
    <path d="m22 10-3 3" />
  </svg>
);

// ✕ Close / X Icon
export const CloseIcon = ({ size = 18, className = '', style = {}, ...props }) => (
  <svg {...defaultProps} width={size} height={size} className={className} style={{ display: 'inline-block', verticalAlign: 'middle', ...style }} {...props}>
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

// ➤ Send / Paper Airplane Icon
export const SendIcon = ({ size = 16, className = '', style = {}, ...props }) => (
  <svg {...defaultProps} width={size} height={size} className={className} style={{ display: 'inline-block', verticalAlign: 'middle', ...style }} {...props}>
    <line x1="22" y1="2" x2="11" y2="13" />
    <polygon points="22 2 15 22 11 13 2 9 22 2" fill="currentColor" stroke="none" />
  </svg>
);

// 📁 Folder Icon
export const FolderIcon = ({ size = 16, className = '', style = {}, ...props }) => (
  <svg {...defaultProps} width={size} height={size} className={className} style={{ display: 'inline-block', verticalAlign: 'middle', ...style }} {...props}>
    <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" />
  </svg>
);

// 💬 Chat Icon alias
export const ChatIcon = SupportIcon;
export const ChatBubbleIcon = SupportIcon;

// ⚙️ Gear / Settings Icon
export const GearIcon = ({ size = 18, className = '', style = {}, ...props }) => (
  <svg {...defaultProps} width={size} height={size} className={className} style={{ display: 'inline-block', verticalAlign: 'middle', ...style }} {...props}>
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
  </svg>
);
export const SettingsIcon = GearIcon;

// 📢 Megaphone / Broadcast Icon
export const MegaphoneIcon = ({ size = 18, className = '', style = {}, ...props }) => (
  <svg {...defaultProps} width={size} height={size} className={className} style={{ display: 'inline-block', verticalAlign: 'middle', ...style }} {...props}>
    <path d="m3 11 18-5v12L3 14v-3z" />
    <path d="M11.6 16.8a3 3 0 1 1-5.8-1.6" />
  </svg>
);

// 🖼️ Photo / Image Icon
export const PhotoIcon = ({ size = 16, className = '', style = {}, ...props }) => (
  <svg {...defaultProps} width={size} height={size} className={className} style={{ display: 'inline-block', verticalAlign: 'middle', ...style }} {...props}>
    <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
    <circle cx="8.5" cy="8.5" r="1.5" />
    <polyline points="21 15 16 10 5 21" />
  </svg>
);

// 📷 Camera Icon (Photo Attachment / Capture)
export const CameraIcon = ({ size = 18, className = '', style = {}, ...props }) => (
  <svg {...defaultProps} width={size} height={size} className={className} style={{ display: 'inline-block', verticalAlign: 'middle', ...style }} {...props}>
    <path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z" />
    <circle cx="12" cy="13" r="3" />
  </svg>
);

// ⏹️ Stop / Finish Icon
export const StopIcon = ({ size = 14, className = '', style = {}, ...props }) => (
  <svg {...defaultProps} width={size} height={size} className={className} style={{ display: 'inline-block', verticalAlign: 'middle', ...style }} {...props}>
    <rect x="5" y="5" width="14" height="14" rx="2" fill="currentColor" stroke="none" />
  </svg>
);


// 💻 / 📱 Devices Icon
export const DevicesIcon = ({ size = 18, className = '', style = {}, ...props }) => (
  <svg {...defaultProps} width={size} height={size} className={className} style={{ display: 'inline-block', verticalAlign: 'middle', ...style }} {...props}>
    <rect x="2" y="3" width="20" height="14" rx="2" />
    <line x1="8" y1="21" x2="16" y2="21" />
    <line x1="12" y1="17" x2="12" y2="21" />
  </svg>
);

// ➕ Plus / Add Icon
export const PlusIcon = ({ size = 16, className = '', style = {}, ...props }) => (
  <svg {...defaultProps} width={size} height={size} className={className} style={{ display: 'inline-block', verticalAlign: 'middle', ...style }} {...props}>
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

